export default __webpack_public_path__ + "static/media/LabTable.a0310357.svg";